import * as ActionTypes from '../../../constants';

const initialState = {
  // A session exists and Run should push to it.
  isActive: false,
  sessionId: null,
  // The QR modal.
  isOpen: false,
  busy: false,
  error: null,
  // The last AR publish found angleMode(DEGREES) in the sketch. Valid p5, and correct in
  // the editor preview — but the AR bridge forces radians, so the angles come out wrong on
  // the phone only. Drives the warning bar over the code pane.
  usesDegrees: false,
  // The student closed that bar. Kept separate from `usesDegrees` so a dismissal survives
  // the many Runs they will do while the sketch still uses degrees.
  degreesDismissed: false
};

const arSession = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AR_SESSION_BUSY:
      return { ...state, busy: action.busy };
    case ActionTypes.AR_SESSION_STARTED:
      return {
        ...state,
        isActive: true,
        sessionId: action.sessionId,
        isOpen: true,
        error: null
      };
    case ActionTypes.AR_SESSION_OPENED:
      return { ...state, isOpen: true };
    case ActionTypes.AR_SESSION_CLOSED:
      return { ...state, isOpen: false };
    case ActionTypes.AR_SESSION_STOPPED:
      return {
        ...state,
        isActive: false,
        isOpen: false,
        usesDegrees: false,
        degreesDismissed: false
      };
    case ActionTypes.AR_DEGREES_USAGE_REPORTED:
      // Re-arm on a false -> true transition: the student removed the degrees and put
      // them back, which is a new problem, so an old dismissal must not silence it.
      // Repeated true -> true reports leave a dismissal standing.
      if (!action.usesDegrees) {
        return { ...state, usesDegrees: false, degreesDismissed: false };
      }
      return state.usesDegrees
        ? state
        : { ...state, usesDegrees: true, degreesDismissed: false };
    case ActionTypes.AR_DEGREES_WARNING_DISMISSED:
      return { ...state, degreesDismissed: true };
    case ActionTypes.AR_SESSION_ERROR:
      return { ...state, error: action.error };
    default:
      return state;
  }
};

export default arSession;
